import React from 'react';
import { getListingCompleteness } from '../../util/listingCompleteness';
import ListingProgressCard from './ListingProgressCard';

const validPackage = {
  pricingModel: 'project',
  price: 240000,
  title: 'Content strategy',
  description: '<p>A complete content strategy in four weeks.</p>',
};

const completeValues = {
  title: 'Content Strategy',
  images: [{ id: 'img-1' }],
  // Descriptions need at least 300 characters
  description: `<p>${'I help B2B companies plan their content. '.repeat(8).trim()}</p>`,
  packages: [validPackage],
};

const CardExample = props => (
  <form onSubmit={e => e.preventDefault()} style={{ maxWidth: 324 }}>
    <ListingProgressCard {...props} />
  </form>
);

// Figma 258:722
export const Incomplete = {
  component: CardExample,
  props: {
    completeness: getListingCompleteness({ ...completeValues, packages: [], images: [] }),
    saveLabel: 'Save as draft',
    saveDisabled: false,
  },
  group: 'service listing',
};

// Figma 274:3916
export const NewComplete = {
  component: CardExample,
  props: {
    completeness: getListingCompleteness(completeValues),
    saveLabel: 'Save and preview',
    saveDisabled: false,
  },
  group: 'service listing',
};

// Figma 274:3963
export const PublishedComplete = {
  component: CardExample,
  props: {
    completeness: getListingCompleteness(completeValues),
    saveLabel: 'Publish edits',
    saveDisabled: false,
  },
  group: 'service listing',
};

export const PublishedIncompleteWithError = {
  component: CardExample,
  props: {
    completeness: getListingCompleteness({ ...completeValues, packages: [] }),
    saveLabel: 'Publish edits',
    saveDisabled: true,
    errorMessage: 'Saving the service failed. Please try again.',
  },
  group: 'service listing',
};
